// @flow
import * as React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useOutdatedSql } from '../../hooks/use-outdated-sql';
import { Link as MuiLink, Stack, Typography } from '@mui/material';
import { BlinkingWarningIcon } from '../../../../features';
import { keycloak } from '@coverright/shared/keycloak';
import { useSalesQualifiedQuery } from '../../../../shared';
import { SalesQualified } from './sales-qualified';


export const TodaySalesQualified = () => {
  const {agentId} = useParams<{ agentId?: string }>();
  const outdated = useOutdatedSql(agentId)
  const outdatedLength =  outdated?.length;

  return (
    <>
      {!!outdatedLength && <Stack mb={1} direction={'row'} gap={1} alignItems={'center'}>
        <BlinkingWarningIcon />
        <Typography variant={'body2'} color={'error'} fontWeight={500}>
          You have {outdatedLength} SQLs that are dates prior to today's date. Please review and update
          your Next Contact Date. <MuiLink component={Link} color={'#0288d1'} to={`/dashboard/outdated-sql/${agentId || keycloak?.tokenParsed?.sub}`}>Show outdated</MuiLink>
        </Typography>
      </Stack>}
      <SalesQualified suffix={'Future'}
                      dataSource={useSalesQualifiedQuery}
                      title={'Today\'s Sales Qualified'}
                      agent={agentId || keycloak?.tokenParsed?.sub} />
    </>
  );
};
